import { useAuthStore } from '../stores'

export async function getSubscription() {
  const { user } = useAuthStore.getState()
  if (!user) return null

  const { backendClient } = await import('./backend')
  const { data: { session } } = await backendClient.auth.getSession()
  const accessToken = session?.access_token
  if (!accessToken) return null

  // Force relative path so Vercel Serverless Functions are hit correctly
  const url = '/api/paystack/get-subscription'

  try {
    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })

    if (!res.ok) return null

    // Guard against non-JSON responses (e.g. HTML fallback pages)
    const contentType = res.headers.get('content-type') || ''
    if (!contentType.includes('application/json')) return null

    const data = await res.json()
    return data.subscription || data
  } catch (e) {
    console.error('Failed to fetch subscription', e)
    return null
  }
}

export default getSubscription
